
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-item/dropdown-item',
    function() {
        return require('components/dropdown/dropdown-item/dropdown-item');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container' />\r\n<can-import from='components/dropdown/dropdown-item/dropdown-item' />\r\n\r\n<div class=\"c-timeline-type-filter\">\r\n    <dropdown-container value=\"all\" (onChange)=\"onChange(%event)\" {{#if expand}}expand-extra-large expand-large expand-medium expand-small{{/if}} align-right>\r\n        {{#each types}}\r\n            {{#.}}\r\n                <dropdown-item analytics-key=\"data-analytics-content-filter\" is-analytics={true} value=\"{{%key}}\" title=\"{{.}}\"></dropdown-item>\r\n            {{/.}}\r\n        {{/each}}\r\n    </dropdown-container>\r\n</div>");